module.exports = __webpack_public_path__ + "img/professional-character.d035de9c.png";